import React, { useState, useContext } from "react";
import "../login.css";
import { LoginContext } from "../../../App";
import axiosInstance from "../../../refershTokenManage/axiosConfig";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import ReCAPTCHA from "react-google-recaptcha";
import CommonLoader from "../../../loader/CommonLoader";

const SignUp = () => {
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    password: "",
    c_password: "",
    phone: null,
    address: "",
  }),
    [errorMessage, setErrorMessage] = useState(""),
    [errors, setErrors] = useState({}),
    { setCreateUser, setUser } = useContext(LoginContext),
    [loading, setLoading] = useState(false),
    navigate = useNavigate();
  const [recaptchaToken, setRecaptchaToken] = useState(null);

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleSignup = async (e) => {
    try {
      e.preventDefault();
      if (!recaptchaToken && process.env.REACT_APP_RECAPTCHA_ENABLED == true) {
        alert("Please complete the reCAPTCHA!");
        return;
      }
      setLoading(true);
      const { name, email, password, c_password, phone, address } = newUser;
      const response = await axiosInstance.post("api/register", {
        name,
        email,
        password,
        c_password,
        phone,
        address,
        recaptchaToken,
        role: "client",
      });

      if (response.status === 201) {
        const { id, name, roles, client, permissions } = response.data.user;
        const token = response.data.accessToken;
        const refreshToken = response.data.refresh_token;
        localStorage.setItem("client_id", client.id);
        localStorage.setItem("userName", name);
        localStorage.setItem("token", token);

        localStorage.setItem("userRole", roles[0].name);
        localStorage.setItem("permissions", JSON.stringify(permissions));
        localStorage.setItem("user_id", id);
        localStorage.setItem("refreshToken", refreshToken);

        setUser({ email, isLoggedIn: true, permissions });
        resetFields();
        toast.success("Successfully created user!");
        setTimeout(navigate("/dashboard"), 10000);
      }
      setLoading(false);
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        setErrorMessage(error.response.data.message);
        setErrors(error.response.data.errors);
      } else {
        setErrorMessage("Something went wrong. Please try again later.");
      }
      setLoading(false);
    }
  };
  const resetFields = () => {
    setNewUser({
      name: "",
      email: "",
      password: "",
      c_password: "",
      // phone: null,
      // address: "",
    });
  };

  return (
    <div className="main container">
      {loading && (
        <div className="loader-overlay">
          <CommonLoader />
        </div>
      )}
      <div className="main__text-wrapper row" style={{ justifyContent: "center" }}>
        <div className="col-md-6">
          <form className="form p-3 p-md-5 sign-up-page-bg">
            <h3 className="mb-2 mb-md-5 sign-up-page">Sign Up</h3>
            <h2 className="mb-5 fs-2 sign-up-page text-center">Create User To Sign In </h2>

            <div style={{ justifyContent: "center !important" }}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Control
                  type="text"
                  placeholder="Enter Your Name "
                  autoFocus
                  value={newUser?.name}
                  onChange={(e) =>
                    setNewUser({ ...newUser, name: e.target.value })
                  }
                  required
                />
                {errors?.name && <p className="error text-danger">{errors.name[0]}</p>}
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Control
                  type="email"
                  className="creatuserListing"
                  placeholder="name@example.com"
                  autoFocus
                  value={newUser?.email}
                  onChange={(e) =>
                    setNewUser({ ...newUser, email: e.target.value })
                  }
                  required
                />
                {errors?.email && <p className="error text-danger">{errors.email[0]}</p>}
              </Form.Group>

              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Control
                  type="password"
                  className="creatuserListing"
                  autoFocus
                  value={newUser?.password}
                  onChange={(e) =>
                    setNewUser({ ...newUser, password: e.target.value })
                  }
                  placeholder="Password"
                  required
                />
                {errors?.password && <p className="error text-danger">{errors.password[0]}</p>}
              </Form.Group>

              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Control
                  type="password"
                  className="creatuserListing"
                  autoFocus
                  value={newUser?.c_password}
                  onChange={(e) =>
                    setNewUser({ ...newUser, c_password: e.target.value })
                  }
                  placeholder="Confirm Password"
                  required
                />
                {errors?.c_password && <p className="error text-danger">{errors.c_password[0]}</p>}
              </Form.Group>
            </div>
            {/* END */}
            {errorMessage && (
              <div className="error-message text-danger fw-bold fs-5 text-center mt-3">
                {errorMessage}
              </div>
            )}
            {process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && (
              <div className="recaptcha">
                <ReCAPTCHA
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={handleRecaptchaChange}
                />
              </div>
            )}
            <div className="button">
              <button
                className="submit"
                onClick={handleSignup}
                disabled={loading}
              >
                Sign Up
              </button>
            </div>
            <div className="newuser sign-up-page" style={{ textAlign: "center" }}>
              Already have an account?
              <span className="ms-2 sign-up-page" onClick={() => setCreateUser(false)}>
                Sign In
              </span>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
